<template>
    <v-toolbar-items wrap style="width: 80%;">
        <template v-for="(item) in menuTree">
            <v-menu v-if="item.items" open-on-hover bottom offset-y dense>
                <template v-slot:activator="{ on }">
                    <v-btn
                            dark
                            flat
                            v-on="on"
                    >
                        <v-icon left>{{item.icon}}</v-icon>
                        {{item.title}}
                    </v-btn>
                </template>
                <v-list color="info" style="background-color: #3BA2F4" dark>
                    <template v-for="(subItem, i) in item.items">
                        <v-list-tile :key="i"
                                :to="genChildTarget(item, subItem)"
                                :href="subItem.href"
                                :disabled="subItem.disabled"
                                :target="subItem.target"
                                ripple="ripple"
                        >
                            <v-list-tile-action v-if="subItem.icon">
                                <v-icon>{{ subItem.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="font-size: 14px" v-text="subItem.title"/>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>
            </v-menu>
            <!--top-level link-->
            <v-btn v-else @click="toPage(item.href)" flat dark>
                <v-icon left v-if="item.icon">{{ item.icon }}</v-icon>
                {{item.title}}
            </v-btn>
        </template>
    </v-toolbar-items>
</template>
<script>
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import {mapGetters} from "vuex";
    import menu from "@/api/menu";

    export default {
        name: "app-menu",
        components: {
            VuePerfectScrollbar,
        },
        props: {
            expanded: {
                type: Boolean,
                default: true,
            },
        },
        data: () => ({
            mini: false,
            drawer: true,
            menus: menu,
            scrollSettings: {
                maxScrollbarLength: 160,
            },
        }),
        computed: {
            ...mapGetters("menu", ["menuTree"]),
            computeGroupActive() {
                return true;
            },
            computeLogo() {
              const domain = window.location.hostname
              if (domain.includes("lms-edusmart.")) {
                return "/img/logo-edusmart1.png"
              }
              if (domain.includes("localhost")) {
                return "/img/logo-edusmart1.png"
              }
              // default
              return "/img/logo.png"
            },

            sideToolbarColor() {
                return this.$vuetify.options.extra.sideNav;
            },
        },
        mounted() {
            if (this.$store.state.auth.loggedIn) {
                this.$store.dispatch("menu/getMenus");
            }

            window.getApp.$on("APP_DRAWER_TOGGLED", () => {
                this.drawer = !this.drawer;
            });
        },

        methods: {
            genChildTarget(item, subItem) {
                if (subItem.href) return;
                if (subItem.component) {
                    return {
                        name: subItem.component,
                    };
                }
                return {name: `${item.group}/${subItem.name}`};
            },

            toPage(href){
                document.location.href = href;
            }
        },
    };
</script>


<style lang="stylus">
    // @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';
    #appDrawer {
        overflow: hidden;

        .drawer-menu--scroll {
            height: calc(100vh - 48px);
            overflow: auto;
        }
    }
</style>
